module.exports = __webpack_public_path__ + "img/pesach-sell-2023.fe4bd185.jpg";